<template>
    <m-portalcontainer text="Cloud">
        <div class="inline-block sprite-portal-cloud" slot="logo"></div>
        <m-pagedtable url="/portal/cloud/usage">
            <template slot="header">
                <th>Subscriber</th>
                <th>Package</th>
                <th>Files Stored</th>
                <th>Used</th>
                <th>Usage</th>
            </template>
            <template v-slot="{row}">
                <td>{{ row.subscriberName }}</td>
                <td>{{ row.package }}</td>
                <td>{{ row.count }}</td>
                <td>{{ row.used | bytes }}</td>
                <td>{{ row.usage | round }} %</td>
            </template>
        </m-pagedtable>
    </m-portalcontainer>
</template>

<script>
export default {}
</script>

